//最基础的cgi
export default class {
	/**
	 *  构造函数主要用来接收与该次请求有关的配置参数
     *	opt.hideLoading 隐藏加载url时的loading
     *	opt.timeout 超时时间
	 */
	constructor(opt = {}) {
		this.hideLoading = opt.hideLoading !== undefined ? opt.hideLoading : false;
		this.timeout = opt.timeout !== undefined ? opt.timeout : 0;
		this.requestType = ['ajax', 'jsonp'].indexOf(opt.requestType) !== -1 ? opt.requestType : 'ajax';
	}

	/**
	 * 定义哪些字段需要放在aes加密里面
	 */
	aesKeys() {
		return [];
	}

	/**
	 * 定义哪些字段一定不能传给后端
	 */
	needDeleteKeys() {
		return [];
	}

	/**
	 * 获取cgi的前半部分，如'https://api.unipay.qq.com/v1/r/1450000173/mobile_month_info'
	 * 该方法接收两个参数
	 * @param cgiObj cgi实例
	 * @param getParams 用户传的get参数
	 */
	getUri() { }

	/**
     * 该方法需要返回cgi名字，如mobile_month_info
     */
	cgiName() { }
}
